(function() {
  'use strict';

  var container = document.getElementById('diwali-fbt');
  if (!container) return;

  var productId = container.getAttribute('data-product-id');
  var collectionHandle = container.getAttribute('data-collection') || '';
  var moneyFormat = theme.settings.moneyFormat || '₹{{amount}}';

  if (!productId) return;

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return moneyFormat.replace('{{amount}}', amount)
      .replace('{{ amount }}', amount)
      .replace('{{amount_no_decimals}}', Math.round(cents / 100))
      .replace('{{ amount_no_decimals }}', Math.round(cents / 100))
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
      .replace('{{ amount_with_comma_separator }}', amount.replace('.', ','));
  }

  function renderCards(products) {
    if (!products || products.length === 0) {
      container.style.display = 'none';
      return;
    }

    var html = '<div class="fbt-header">' +
      '<h3 class="fbt-title">Frequently Bought Together</h3>' +
      '</div><div class="fbt-grid">';

    for (var i = 0; i < products.length; i++) {
      var p = products[i];
      var img = p.featured_image || (p.images && p.images[0]) || '';
      if (typeof img === 'object' && img.src) img = img.src;
      if (typeof img === 'string' && img.indexOf('cdn.shopify') !== -1) {
        img = img.replace(/(\.[a-z]+)\?/, '_300x$1?');
      }

      var price = p.price || (p.variants && p.variants[0] ? p.variants[0].price : 0);
      var comparePrice = p.compare_at_price || (p.variants && p.variants[0] ? p.variants[0].compare_at_price : null);
      var variantId = p.variants && p.variants[0] ? p.variants[0].id : p.id;
      var url = p.url || ('/products/' + p.handle);

      html += '<div class="fbt-card" data-variant-id="' + variantId + '">' +
        '<label class="fbt-checkbox-wrap">' +
        '<input type="checkbox" class="fbt-check" checked data-variant="' + variantId + '">' +
        '</label>' +
        '<a href="' + url + '" class="fbt-image-link">' +
        '<img src="' + img + '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" class="fbt-img" loading="lazy">' +
        '</a>' +
        '<div class="fbt-info">' +
        '<a href="' + url + '" class="fbt-product-title">' + p.title + '</a>' +
        '<div class="fbt-price">';

      if (comparePrice && comparePrice > price) {
        html += '<span class="fbt-compare-price">' + formatMoney(comparePrice) + '</span> ';
      }
      html += '<span class="fbt-current-price">' + formatMoney(price) + '</span>';
      html += '</div></div></div>';

      if (i < products.length - 1) {
        html += '<div class="fbt-plus">+</div>';
      }
    }

    html += '</div><div class="fbt-action">' +
      '<button class="fbt-add-btn" type="button">Add Selected to Cart</button>' +
      '</div>';

    container.innerHTML = html;
    container.style.display = 'block';

    container.querySelector('.fbt-add-btn').addEventListener('click', function() {
      var checked = container.querySelectorAll('.fbt-check:checked');
      if (checked.length === 0) return;

      var items = [];
      for (var j = 0; j < checked.length; j++) {
        items.push({ id: parseInt(checked[j].getAttribute('data-variant')), quantity: 1 });
      }

      var btn = this;
      btn.disabled = true;
      btn.textContent = 'Adding...';

      fetch(theme.routes.cartAdd, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function(r) {
        if (!r.ok) throw new Error('Add failed: ' + r.status);
        return r.json();
      }).then(function() {
        btn.textContent = 'Added!';
        setTimeout(function() {
          btn.disabled = false;
          btn.textContent = 'Add Selected to Cart';
        }, 2000);
      }).catch(function(err) {
        console.error('FBT add failed:', err.message);
        btn.disabled = false;
        btn.textContent = 'Add Selected to Cart';
      });
    });
  }

  function fetchRecommendations() {
    var url = '/recommendations/products.json?product_id=' + productId + '&limit=4';

    return fetch(url, { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data.products && data.products.length > 0) return data.products;
        return fetchCollectionFallback();
      })
      .catch(function() { return fetchCollectionFallback(); });
  }

  function fetchCollectionFallback() {
    if (!collectionHandle) return [];
    var url = '/collections/' + collectionHandle + '/products.json?limit=5';

    return fetch(url, { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        return (data.products || []).filter(function(p) {
          return String(p.id) !== String(productId);
        }).slice(0, 4);
      })
      .catch(function() { return []; });
  }

  fetchRecommendations().then(renderCards);
})();
